import {Object3D} from "three";
import {Constructor} from "../../util/constructor-wrapper";

/**
 * Provides attribute resolution for implementations of the Extendable feature
 */
interface ExtendableMapping<T extends Object3D<any>> {
    _object: T
}

/**
 * interface of the Extendable feature
 */
export interface Extendable {
    extend(object: Object3D): void
}

/**
 * Mixin for the Extendable feature. This is used to Extend Objects or groups with other objects
 * @param base
 */
export function Extendable<Tbase extends Constructor<ExtendableMapping<any>>>(base: Tbase): Constructor<Extendable> {

    return class Extendable extends base implements Extendable {
        extend(object: Object3D): void {
            this._object.add(object);
        }
    };

}